import {
  BuddyUserMentee,
  BuddyUserMentor,
  DefaultMenteeUser,
  DefaultMentorUser,
} from '@adornis/bh-matching-user/entities/buddy-user.js';

let menteeUserClass: typeof BuddyUserMentee = DefaultMenteeUser;
let mentorUserClass: typeof BuddyUserMentor = DefaultMentorUser;

export const setUserClass = ({
  mentee,
  mentor,
}: {
  mentee: typeof BuddyUserMentee;
  mentor: typeof BuddyUserMentor;
}) => {
  menteeUserClass = mentee;
  mentorUserClass = mentor;
};

export const getMenteeUserClass = () => menteeUserClass;
export const getMentorUserClass = () => mentorUserClass;
export const getUserClasses = () => ({ mentee: menteeUserClass, mentor: mentorUserClass });
